import React from "react";
import { useState } from "react";
import { useEffect, useMemo } from "react";
import { useSelector } from "react-redux";
import axios from "axios";
import { NavLink, useHistory } from 'react-router-dom'
import { styled, css } from '@mui/material/styles';
import star from './assets/star.png';
import logo from './assets/clientlabel.png';
import { FaStar, FaStarHalfAlt } from 'react-icons/fa';
import { AiOutlineStar } from 'react-icons/ai';
import { useTheme } from '@mui/material'
import defaultimg from './assets/defaultimge.png';
import { safeArrayAccess, } from '../utils/apiHelpers';
import { toast } from 'react-toastify';
import AWS from 'aws-sdk';
import { useAuthToken } from "../TokenContext";
import { useIntl } from 'react-intl';
import { useCredentials } from '../useCredentials';

const Reviewsandratingcandidate = () => {
  const { credentials, } = useCredentials();
  const theme = useTheme();
  const history = useHistory();
  const isDarkMode = theme.palette.mode === 'dark';


  const S3Config = useMemo(() => ({
    bucketName: credentials.bucketName,
    region: credentials.region,
    accessKeyId: credentials.accessKeyId,
    secretAccessKey: credentials.secretAccessKey
  }), [credentials]);

  const token = useAuthToken();
  const intl = useIntl();
  const myBucket = new AWS.S3(S3Config);
  const [Starrating, setStarrating] = useState();
  const [, setAuthImage] = useState("");

  function generatePreSignedPutUrl11(picture) {
    const URL_EXPIRATION_TIME = 900;
    const params = {
      Bucket: process.env.REACT_APP_BUCKETNAME,
      Key: picture,
      Expires: URL_EXPIRATION_TIME,
    }
    myBucket.getSignedUrl('getObject', params, (err, url) => {
      setAuthImage(url);
    });
  }



  const { user } = useSelector(state => state.auth);
  const [getdata, setGetData] = useState([]);
  const [GetPodData, setGetPodData] = useState([]);



  useEffect(() => {
    const headers = {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    };

    const body = { "candidateID": user.data[0].c_id };

    axios.post(process.env.REACT_APP_TALENT_CANDIDATEREVIEW, body, { headers: headers })
      .then((res) => {
        if (!Array.isArray(res.data?.data) || res.data.data.length === 0) {
          // Handle no reviews case
          setGetData([]);
          toast.info('No reviews available yet');
        } else {
          setGetData(res.data.data);
        }
      })
      .catch((err) => {
        console.log("catch", err);
      })

    axios.post(process.env.REACT_APP_TALENT_GETPODMEMBERREVIEW, body, { headers: headers })
      .then((res) => {

        if (Array.isArray(res.data?.data) && res.data.data.length > 0) {
          const totalRating = res.data.data.reduce((sum, item) => sum + (item.rating || 0), 0);
          const averageRating = totalRating / res.data.data.length;
          setStarrating(averageRating);
        } else {
          setStarrating(0);
          console.log('No ratings available');
        }
        const firstItem = safeArrayAccess(res.data?.data, 0);
        if (firstItem && firstItem.profilePicture) {
          generatePreSignedPutUrl11(firstItem.profilePicture);
        } else {
          console.warn('No profile picture found in response');
          toast.warning('Profile picture not available');
        }
        if (!Array.isArray(res.data?.data) || res.data.data.length === 0) {
          // Handle no reviews case
          setGetPodData([]);
          toast.info('No reviews available yet');
        } else {
          setGetPodData(res.data.data);
        }
      })
      .catch((err) => {
        console.log("catch", err);
      })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  const intervals = [
    { label: 'year', seconds: 31536000 },
    { label: 'month', seconds: 2592000 },
    { label: 'day', seconds: 86400 },
    { label: 'hour', seconds: 3600 },
    { label: 'minute', seconds: 60 },
    { label: 'second', seconds: 1 }
  ];

  function timeSince(date) {
    const seconds = Math.floor((Date.now() - date.getTime()) / 1000);
    const interval = intervals.find(i => i.seconds < seconds);
    if (!interval) return 'just now';
    const count = Math.floor(seconds / interval.seconds);
    return `${count} ${interval.label}${count !== 1 ? 's' : ''} ago`;
  }

  const ratingStar = Array.from({ length: 5 }, (elem, index) => {
    let number = index + 0.5;
    return (
      <StarIcon key={index} isDarkMode={isDarkMode}>
        {Starrating >= index + 1 ?
          (<FaStar />) : Starrating >= number ? (<FaStarHalfAlt />) : (<AiOutlineStar />)}
      </StarIcon>
    )
  })

  return (
    <Container isDarkMode={isDarkMode}>
      {/* Page Header */}
      <div style={{ marginBottom: '28px', paddingBottom: '20px', borderBottom: '1px solid var(--artemy-border)' }}>
        <h1 style={{
          fontFamily: 'var(--artemy-font-display)',
          fontSize: '24px',
          fontWeight: 700,
          color: 'var(--artemy-text-primary)',
          margin: 0,
          letterSpacing: '-0.4px'
        }}>
          {intl.formatMessage({ id: 'review', defaultMessage: 'Review & Rating' })}
        </h1>
        <p style={{
          fontSize: '13px',
          color: 'var(--artemy-text-secondary)',
          margin: '6px 0 0',
          fontFamily: 'var(--artemy-font-body)',
        }}>
          View feedback and ratings for your profile
        </p>
      </div>

      {/* Tab Switcher */}
      <div style={{ display: 'flex', gap: '8px', marginBottom: '24px', backgroundColor: 'rgba(255,255,255,0.03)', borderRadius: '14px', padding: '6px', border: '1px solid var(--artemy-border)' }}>
        <button
          onClick={() => history.push('/Reviewsandratingcandidate')}
          style={{
            flex: 1,
            minHeight: '44px',
            borderRadius: '10px',
            border: 'none',
            cursor: 'pointer',
            fontSize: '14px',
            fontWeight: 600,
            fontFamily: 'var(--artemy-font-body)',
            backgroundColor: 'var(--artemy-accent)',
            color: '#fff',
            transition: 'all 0.2s',
            boxShadow: '0 4px 12px rgba(61, 127, 255, 0.2)'
          }}
        >
          {intl.formatMessage({ id: 'individual', defaultMessage: 'Individual Feedback' })}
        </button>
        <button
          onClick={() => history.push('/ReviewsandratingPodcandidate')}
          style={{
            flex: 1,
            minHeight: '44px',
            borderRadius: '10px',
            border: 'none',
            cursor: 'pointer',
            fontSize: '14px',
            fontWeight: 600,
            fontFamily: 'var(--artemy-font-body)',
            backgroundColor: 'transparent',
            color: 'var(--artemy-text-secondary)',
            transition: 'all 0.2s',
          }}
        >
          {intl.formatMessage({ id: 'POD', defaultMessage: 'Pod Feedback' })}
        </button>
      </div>

      <ContentWrapper>
        {user.data[0].isPodLeader === "true" ? (
          <ReviewsContainer isDarkMode={isDarkMode}>
            {GetPodData.length > 0 ?
              GetPodData.map((item, index) => (
                <ReviewCard key={index} isDarkMode={isDarkMode}>
                  <ReviewHeader>
                    <UserInfo>
                      <ProfileImage>
                        {item.profilePicture == null ? (
                          <img
                            src={defaultimg}
                            alt=""
                            style={{ width: 50, height: 50, borderRadius: "50%" }}
                          />
                        ) : (
                          <img
                            src={'https://globldata.s3.amazonaws.com/' + item.profilePicture}
                            alt=""
                            style={{ width: 50, height: 50, borderRadius: "50%" }}
                          />
                        )}
                      </ProfileImage>
                      <UserDetails>
                        <UserName isDarkMode={isDarkMode}>
                          {item.podName}
                          <RatingContainer>
                            {ratingStar}
                          </RatingContainer>
                        </UserName>
                        <TimeStamp isDarkMode={isDarkMode}>
                          {timeSince(new Date(item.createdAt))}
                        </TimeStamp>
                      </UserDetails>
                    </UserInfo>
                  </ReviewHeader>

                  <ReviewDetails isDarkMode={isDarkMode}>
                    <DetailRow>
                      <Label isDarkMode={isDarkMode}>
                        {intl.formatMessage({ id: 'client' })}:
                      </Label>
                      <Value isDarkMode={isDarkMode}>
                        {item.emp_firstname + " " + item.emp_lastname}
                      </Value>
                    </DetailRow>
                    <DetailRow>
                      <Label isDarkMode={isDarkMode}>
                        {intl.formatMessage({ id: 'candidate' })}:
                      </Label>
                      <Value isDarkMode={isDarkMode}>
                        {item.firstName + " " + item.lastName}
                      </Value>
                    </DetailRow>
                  </ReviewDetails>

                  <ReviewText isDarkMode={isDarkMode}>
                    {item.review}
                  </ReviewText>
                </ReviewCard>
              )) : (
                <EmptyState isDarkMode={isDarkMode}>
                  {intl.formatMessage({ id: 'noCandidateReviews' })}
                </EmptyState>
              )}
          </ReviewsContainer>
        ) : (
          <ReviewsContainer isDarkMode={isDarkMode}>
            {getdata.length > 0 ?
              getdata.map((item, index) => (
                <ReviewCard key={index} isDarkMode={isDarkMode}>
                  <ReviewHeader>
                    <UserInfo>
                      <ProfileImage>
                        <img
                          src={logo}
                          alt=""
                          style={{ width: 50, height: 50, borderRadius: "50%" }}
                        />
                      </ProfileImage>
                      <UserDetails>
                        <UserName isDarkMode={isDarkMode}>
                          {item.emp_firstname}
                          <SimpleRating isDarkMode={isDarkMode}>
                            <img width="16px" height="16px" src={star} alt="star" />
                            {item.rating}
                          </SimpleRating>
                        </UserName>
                        <TimeStamp isDarkMode={isDarkMode}>
                          {timeSince(new Date(item.createdAt))}
                        </TimeStamp>
                      </UserDetails>
                    </UserInfo>
                  </ReviewHeader>

                  <ReviewText isDarkMode={isDarkMode}>
                    {item.review}
                  </ReviewText>
                </ReviewCard>
              )) : (
                <EmptyState isDarkMode={isDarkMode}>
                  {intl.formatMessage({ id: 'noCandidateReviews' })}
                </EmptyState>
              )}
          </ReviewsContainer>
        )}
      </ContentWrapper>
    </Container>
  );
};

// Styled Components with Dark Mode Support
const Container = styled('div')`
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem;
  background-color: var(--artemy-bg-base);
  min-height: calc(100vh - 64px);
  box-sizing: border-box;

  @media screen and (max-width: 768px) {
    padding: 1rem;
  }
`;

const Header = styled('div')`
  margin-bottom: 2rem;
`;

const TitleText = styled('h1')`
  font-size: 2rem;
  font-weight: 700;
  color: ${props => props.isDarkMode ? '#ffffff' : '#2c3e50'};
  margin-bottom: 1.5rem;
  text-align: center;
  
  @media screen and (max-width: 768px) {
    font-size: 1.5rem;
  }
`;

const NavigationTabs = styled('div')`
  display: flex;
  justify-content: center;
  gap: 1rem;
  margin-bottom: 2rem;

  @media screen and (max-width: 768px) {
    flex-direction: column;
    gap: 0.5rem;
  }
`;

const navTabBase = css`
  padding: 0.75rem 2rem;
  border-radius: 25px;
  text-decoration: none;
  font-weight: 600;
  transition: all 0.3s ease;
  border: 2px solid transparent;

  @media screen and (max-width: 768px) {
    padding: 0.5rem 1rem;
    text-align: center;
  }
`;

const NavTab = styled(NavLink)`
  ${navTabBase}
  background-color: ${props => props.isDarkMode ? '#2c2c2c' : '#f8f9fa'};
  color: ${props => props.isDarkMode ? '#b0b0b0' : '#6c757d'};
  border-color: ${props => props.isDarkMode ? '#404040' : '#dee2e6'};

  &:hover {
    background-color: ${props => props.isDarkMode ? '#404040' : '#e9ecef'};
    color: ${props => props.isDarkMode ? '#ffffff' : '#495057'};
  }
`;

const NavTabActive = styled(NavLink)`
  ${navTabBase}
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);
  }
`;

const ContentWrapper = styled('div')`
  display: flex;
  justify-content: center;
`;

const ReviewsContainer = styled('div')`
  width: 100%;
  max-width: 800px;
`;

const ReviewCard = styled('div')`
  background-color: var(--artemy-bg-elevated);
  border-radius: 16px;
  padding: 1.5rem;
  margin-bottom: 1.5rem;
  border: 1px solid var(--artemy-border);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.15);
  }

  @media screen and (max-width: 768px) {
    padding: 1rem;
  }
`;

const ReviewHeader = styled('div')`
  margin-bottom: 1rem;
`;

const UserInfo = styled('div')`
  display: flex;
  align-items: center;
  gap: 1rem;
`;

const ProfileImage = styled('div')`
  flex-shrink: 0;
  
  img {
    object-fit: cover;
    border: 3px solid ${props => props.isDarkMode ? '#404040' : '#e9ecef'};
  }
`;

const UserDetails = styled('div')`
  flex: 1;
`;

const UserName = styled('h3')`
  font-size: 1.1rem;
  font-weight: 600;
  color: var(--artemy-text-primary);
  margin-bottom: 0.25rem;
  display: flex;
  align-items: center;
  gap: 1rem;
  flex-wrap: wrap;
`;

const TimeStamp = styled('span')`
  font-size: 0.875rem;
  color: ${props => props.isDarkMode ? '#b0b0b0' : '#6c757d'};
  font-weight: 500;
`;

const RatingContainer = styled('div')`
  display: flex;
  gap: 0.125rem;
`;

const StarIcon = styled('span')`
  color: #ffc107;
  font-size: 1rem;
`;

const SimpleRating = styled('div')`
  display: flex;
  align-items: center;
  gap: 0.25rem;
  font-size: 0.875rem;
  font-weight: 600;
  color: ${props => props.isDarkMode ? '#ffc107' : '#f39c12'};
`;

const ReviewDetails = styled('div')`
  margin-bottom: 1rem;
`;

const DetailRow = styled('div')`
  display: flex;
  gap: 0.5rem;
  margin-bottom: 0.5rem;
  flex-wrap: wrap;
`;

const Label = styled('span')`
  font-weight: 600;
  color: ${props => props.isDarkMode ? '#b0b0b0' : '#6c757d'};
  min-width: 80px;
`;

const Value = styled('span')`
  color: var(--artemy-text-primary);
  font-weight: 500;
`;

const ReviewText = styled('p')`
  color: var(--artemy-text-secondary);
  line-height: 1.6;
  font-size: 1rem;
  margin: 0;
  word-wrap: break-word;
`;

const EmptyState = styled('div')`
  text-align: center;
  padding: 3rem 1rem;
  color: ${props => props.isDarkMode ? '#b0b0b0' : '#6c757d'};
  font-size: 1.1rem;
  background-color: ${props => props.isDarkMode ? '#1e1e1e' : '#f8f9fa'};
  border-radius: 16px;
  border: 2px dashed ${props => props.isDarkMode ? '#404040' : '#dee2e6'};
`;

export default Reviewsandratingcandidate;